import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = { class: "search-input__group" }
const _hoisted_3 = { class: "input-group-text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["src"]

import { ref, watch, onBeforeUnmount } from 'vue';
import { SEARCH_MIN_LENGTH } from '@/js/utils/search-input';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    modelValue: { default: '' },
    placeholder: { default: 'Найти...' },
    debounce: { default: 400 }
  },
  emits: ["update:modelValue", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const inputValue = ref(props.modelValue);

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

let timer: ReturnType<typeof setTimeout> | null = null;
let lastEmittedSearch = '';

watch(
  () => props.modelValue,
  (value) => {
    inputValue.value = value;
  },
);

watch(inputValue, (value) => {
  emit('update:modelValue', value);

  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(() => {
    const trimmed = value.trim();

    if (!trimmed) {
      if (lastEmittedSearch) {
        lastEmittedSearch = '';
        emit('search', '');
      }
      return;
    }

    if (trimmed.length >= SEARCH_MIN_LENGTH) {
      lastEmittedSearch = trimmed;
      emit('search', trimmed);
      return;
    }

    if (lastEmittedSearch.length >= SEARCH_MIN_LENGTH) {
      lastEmittedSearch = '';
      emit('search', '');
    }
  }, props.debounce);
});

function clear() {
  inputValue.value = '';
  lastEmittedSearch = '';
  emit('search', '');
}

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon", {}, () => [
          _createElementVNode("img", {
            src: `${_unref(ICONS_BASE)}/search-icon.svg`,
            alt: ""
          }, null, 8, _hoisted_4)
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        type: "text",
        id: "residencyRequestsSearch",
        class: "form-control",
        placeholder: __props.placeholder,
        autocomplete: "off"
      }, null, 8, _hoisted_5), [
        [_vModelText, inputValue.value]
      ]),
      _withDirectives(_createElementVNode("button", {
        type: "button",
        class: "search-input__clear",
        onClick: clear
      }, [
        _renderSlot(_ctx.$slots, "clear-icon", {}, () => [
          _createElementVNode("img", {
            src: `${_unref(ICONS_BASE)}/search-close-icon.svg`,
            alt: ""
          }, null, 8, _hoisted_6)
        ])
      ], 512), [
        [_vShow, inputValue.value]
      ])
    ])
  ]))
}
}

})